import { DialogService } from '../../shared/components/dialog/services/dialog.service';

export namespace GlobalDialogReference {
  export function initialise(dialogServiceRef: DialogService) {
    DialogManager = {
      openDialog: dialogServiceRef.openDialog.bind(dialogServiceRef),
      openRetryDialog: dialogServiceRef.openRetryDialog.bind(dialogServiceRef),
      openConfirmDialog: dialogServiceRef.openConfirmDialog.bind(dialogServiceRef),
      openLoadingDialog: dialogServiceRef.openLoadingDialog.bind(dialogServiceRef),
    };
  }
}

export let DialogManager!: {
  openDialog: DialogService['openDialog'];
  openRetryDialog: DialogService['openRetryDialog'];
  openConfirmDialog: DialogService['openConfirmDialog'];
  openLoadingDialog: DialogService['openLoadingDialog'];
};
